import { render, staticRenderFns } from "./TabGraficoCapitalImobilizadoCirculante.vue?vue&type=template&id=73372a45&scoped=true&"
import script from "./TabGraficoCapitalImobilizadoCirculante.vue?vue&type=script&lang=js&"
export * from "./TabGraficoCapitalImobilizadoCirculante.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoCapitalImobilizadoCirculante.vue?vue&type=style&index=0&id=73372a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73372a45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTab,VTabItem,VTabs})
